<template>
  <!--
    Login Page
  -->
<div>
  <logout-notification v-if="showLogoutNotification"></logout-notification>
    <div class="col-lg-6 offset-lg-3 col-md-8 offset-md-2 card" id="login-card">
    <div class="card-body">
      <h2 class="mb-4" id="xmcp-title"><span>XMission</span> Control Panel</h2>
      <form @submit.prevent="login">
        <div class="form-group">
          <label>Username</label>
          <input type="text" name="username" autofill="username" class="form-control mb-4" v-model="username" autocomplete="on"/>
        </div>
        <div class="form-group mb-5">
          <label>Password</label>
          <b-icon-eye-slash-fill v-if="passwordFieldType === 'password'" @click="switchVisibility" aria-hidden="true"/>
          <b-icon-eye-fill v-if="passwordFieldType === 'text'" @click="switchVisibility" aria-hidden="true"/>
          <input :type="passwordFieldType" name="password" autofill="password" type="password" class="form-control" v-model="password" autocomplete="on"/>
        </div>
        <button type="submit" class="btn float-right btn-primary btn-lg"><b>Log In</b></button>
      </form>
      <router-link to="username-recovery" class="btn btn-sm btn-light mt-2">Login Help</router-link><span>&nbsp;</span>
    </div>
  </div>
  <change-password-modal/>
</div>
</template>

<script>
  import { mapState } from 'vuex'
  import * as types from '../store/mutation-types'
  import LogoutNotification from '@/components/LogoutNotification'
  import ChangePasswordModal from '../components/Modals/ChangePasswordModal'
  import { ModalPlugin, BIconEyeFill, BIconEyeSlashFill, BButton } from 'bootstrap-vue'
  import Vue from 'vue'
  Vue.use(ModalPlugin)

  export default {
    components: {
      LogoutNotification,
      ChangePasswordModal,
      BIconEyeFill,
      BIconEyeSlashFill,
      BButton
    },
    data () {
      return {
        // Form fields
        username: '',
        password: '',
        // If there is a form error
        hasError: false,
        passwordFieldType: 'password'
      }
    },

    mounted () {
      this.checkLoggedIn()
      this.checkTimeout()
      this.checkPassword()
    },

    computed: {
      lowercaseUsername () {
        return this.username.toLowerCase()
      },
      // Computed property for existence of the URL parameter timeout
      timeout () {
        if (this.$route.query !== undefined && this.$route.query.timeout !== undefined) {
          return true
        } else {
          return false
        }
      },
      redirect () {
        if (this.$route.query !== undefined && this.$route.query.redirect !== undefined) {
          // Route the user was at before timeout
          return this.$route.query.redirect
        } else {
          // Default route after login
          return 'account'
        }
      },
      // If we got to this page from xmission.com/password
      passwordRedirect () {
        return this.$route.query !== undefined && this.$route.query.password !== undefined
      },
      // ECMAScript6 object spread operator. Allows the use of Vuex state and
      // regular Vue state to coexist
      ...mapState({
        loggedIn: state => state.user.loggedIn,
        showLogoutNotification: state => state.notifications.showLogoutNotification
      })
    },

    methods: {
      /*
       * Changes the password field to text to show.
       */
      switchVisibility () {
        this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
      },
      // Redirect to the account page if this user is logged in or has a valid
      // token
      checkLoggedIn () {
        if (this.$store.state.user.loggedIn === undefined) {
          this.$store.dispatch('getProfile').then(response => {
            if (this.$store.state.user.loggedIn) {
              this.$router.push({ name: 'account' })
            }
          })
        } else if (this.$store.state.user.loggedIn) {
          this.$router.push({ name: 'account' })
        }
      },
      /*
       * Check for the url timeout parameter and display a notification if it exists
       */
      checkTimeout () {
        if (this.$route.query !== undefined && this.$route.query.timeout !== undefined) {
          this.$store.commit(types.ADD_NOTIFICATION, {
            type: 'warning',
            message: 'Your session has timed out and you need to relogin'
          })
        }
      },
      checkPassword () {
        if (!this.$store.state.user.loggedIn && this.passwordRedirect) {
          this.$store.commit(types.ADD_NOTIFICATION, {
            type: 'info',
            message: 'Please login to change your password'
          })
        }
      },
      /*
       * Send an AJAX request to login. If successful sets cookies with authentication
       * tokens and additional information.
       */
      login () {
        if (this.username.includes('@')){
          this.$store.commit(types.ADD_NOTIFICATION, {'type': 'warning', 'message': 'Username cannot be an email address. If you don\'t know yours please click "Recover Username"'})
          this.username = this.username.split('@')[0]
          return
        }
        this.$store.dispatch('login', {
          username: this.lowercaseUsername,
          password: this.password
        }).then(() => {
          this.clearForm()
          if (this.passwordRedirect) {
            this.$bvModal.show('change-password-modal')
          }
          this.$router.push({ name: this.redirect })
        }, (errorMessage) => {
          this.clearForm()
          this.$store.commit(types.ADD_NOTIFICATION, {
            type: 'error',
            message: errorMessage
          })
        })
      },
      clearForm () {
        this.username = ''
        this.password = ''
      }
    }
  }
</script>


<style scoped>
#login-card {
  background-color: #fff;
  border: 1px solid rgba(0,0,0,.125);
  color: #212529;
}

.liteMode #login-card {
  box-shadow:0 0 255px #bbb;
}

#login-card .card-body {
  background-color: #fff;
  color: #212529;
}

#login-card input[type=text], #login-card input[type=password] {
  border: 1px solid #bbb;
  background-color:#f5f5f5;
  padding:8px 12px;
  font-size:110%;
  color:black;
}

#login-card input[type=text]:focus, #login-card input[type=password]:focus {
  background-color:white !important;
}

#login-card input::placeholder {
  font-size:14px;
  color:#aaa
}

#login-card label {
  margin-bottom: 0.3rem;
}

#login-card .btn-light {
  color: #212529 !important;
  background:#E2E6EA !important;
  border:1px solid #ccc !important;
}

#login-card .btn-light:hover {
  background:#cbcfd3 !important;
  border-color:#aaa !important;
}

#login-card .btn-primary {
  background-color:#0290AE !important;
  color:white !important;
  border-color: #0290AE !important;
}

#login-card .btn-primary:hover {
  background-color:#027a94 !important;
  border-color:#027a94 !important;
}

/** responsive **/
@media (max-width: 950px) {
  #xmcp-title span {
    display:block;
    font-size:50%;
  }
}

</style>



// WEBPACK FOOTER //
// Login.vue?30dbc780